export interface AppointmentReview {
  id: number;
  rating: number;
  comment?: string | null;
  createdAt: string;
}

export enum AppointmentStatus {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
}

export interface ExpertInfo {
  id: number;
  name: string;
  avatar?: string;
}

export interface ClientInfo {
  id: number;
  name: string;
  avatar?: string;
}

export interface AppointmentResponseDto {
  id: number;
  expert: ExpertInfo;
  client: ClientInfo;
  scheduledAt: string; // ISO 8601
  durationMinutes: number;
  status: AppointmentStatus;
  clientNotes?: string | null;
  expertNotes?: string | null;
  outcome?: string | null;
  cancelledAt?: string | null; // ISO 8601
  cancellationReason?: string | null;
  cancelledBy?: 'client' | 'expert' | null;
  createdBy?: 'client' | 'expert' | null; // хто ініціював запис (потребує для визначення, кто має підтвердити)
  createdAt: string; // ISO 8601
  review?: AppointmentReview | null;
}

export interface Pagination {
  total: number;
  pages: number;
  currentPage: number;
  limit: number;
}

export interface AppointmentsListResponseDto {
  success: boolean;
  message: string;
  data: AppointmentResponseDto[];
  pagination?: Pagination;
  meta?: Pagination;
}

export interface CancelAppointmentDto {
  cancellationReason: string;
}

export interface RescheduleAppointmentDto {
  scheduledAt: string; // ISO 8601 UTC
  clientNotes?: string;
}

export interface CreateAppointmentByExpertDto {
  clientId: number;
  scheduledAt: string; // ISO 8601 UTC
  expertNotes?: string;
}

export interface AppointmentStatusOption {
  value: string;
  label: string;
}

export interface AppointmentParticipantOption {
  id: number;
  name: string;
  avatar?: string;
}

export interface AppointmentOptions {
  statuses: AppointmentStatusOption[];
  clients: AppointmentParticipantOption[];
  experts: AppointmentParticipantOption[];
  statusCounts?: Record<string, number> | null;
}

export interface WorkingHoursDto {
  dayOfWeek: number; // 1 = Monday, ..., 7 = Sunday
  startTime: string; // "HH:mm"
  endTime: string; // "HH:mm"
  isActive: boolean;
}

export interface UpdateScheduleDto {
  workingHours: WorkingHoursDto[];
}

export interface CompleteAppointmentDto {
  expertNotes?: string;
}

export interface AppointmentSettingsDto {
  slotDurationMinutes: number;
  bufferMinutes?: number;
  advanceBookingDays?: number;
}

export interface TimeOffResponseDto {
  id: number;
  startDate: string; // "YYYY-MM-DD"
  endDate: string; // "YYYY-MM-DD"
  reason?: string;
  createdAt: string; // ISO 8601
}

export interface CreateTimeOffDto {
  startDate: string; // "YYYY-MM-DD"
  endDate: string; // "YYYY-MM-DD"
  reason?: string;
}
